import { createLibp2pNode } from './libp2p.js';
/**
 * Returns a new instance of the Libp2p interface, generating a new PeerId
 * if one is not passed as part of the options.
 */
export async function createLibp2p(options) {
    return await createLibp2pNode(options);
}
